import { render } from "./LoginSso.vue?vue&type=template&id=e27d5a66"
import script from "./LoginSso.vue?vue&type=script&lang=js"
export * from "./LoginSso.vue?vue&type=script&lang=js"

import "./LoginSso.vue?vue&type=style&index=0&id=e27d5a66&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__